import { Divider } from "primereact/divider";
import { useTranslation } from "react-i18next"


export function BlocknatorPolicyView () {
  const {t} = useTranslation();

  return <>
    <h1>{t('policy.title')}</h1>
    <Divider/>
    <p>{t('game.blocknator.policy.description')}</p>
    <h2>{t('game.blocknator.policy.personal_data')}</h2>
    <Divider/>
    <p>{t('game.blocknator.policy.personal_data_desc_01')}</p>
    <p>{t('game.blocknator.policy.personal_data_desc_02')}</p>
    <h2>{t('game.blocknator.policy.policy_update')}</h2>
    <Divider/>
    <p>{t('game.blocknator.policy.policy_update_desc_01')}</p>
    <p>{t('game.blocknator.policy.policy_update_desc_02')}</p>
    <h2>{t('game.blocknator.policy.contact')}</h2>
    <Divider/>
    <p>
      {t('game.blocknator.policy.contact_desc_01')}
      <a className="pink-text" href="mailto:support@unipigstudio.com">support@unipigstudio.com</a>
    </p>
  </>  
}